/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { useBulkImportStore } from '../hooks/useBulkImportStore'

import { type CardActivityWithId } from '@/models/card-activity/card-activity.model'

interface HandleUpdateBulkProps {
  cardId: string
  fieldToUpdate: keyof CardActivityWithId | 'image.url'
  updates?: any
}

function setNestedValue(obj: any, path: string, value: any): any {
  const keys = path.split('.')
  const lastKey = keys.pop()

  if (!lastKey) return obj

  const newObj = { ...obj }
  let curr = newObj

  for (const key of keys) {
    if (!(key in curr)) curr[key] = {}
    curr[key] = { ...curr[key] }
    curr = curr[key]
  }

  curr[lastKey] = value

  return newObj
}

function handleUpdateFieldTable(instructions: HandleUpdateBulkProps[]) {
  useBulkImportStore.setState(state => {
    const cards = state.cards
    const updatedCards = new Map(cards)

    for (const { cardId, fieldToUpdate, updates } of instructions) {
      const card = updatedCards.get(cardId)

      const updatedCard = setNestedValue(card, fieldToUpdate, updates) as CardActivityWithId

      updatedCards.set(cardId, updatedCard)
    }

    return {
      ...state,
      cards: updatedCards,
    }
  })
}

function bulkDeleteBulk(cardIds: string[]) {
  useBulkImportStore.setState(state => {
    const cards = state.cards
    const updatedCards = new Map(cards)

    cardIds.forEach(id => {
      updatedCards.delete(id)
    })

    return {
      ...state,
      cards: updatedCards,
      selectedCards: [],
    }
  })
}

function handleSelectCards(cardId: string) {
  useBulkImportStore.setState(state => {
    const isSelected = state.selectedCards.includes(cardId)

    return {
      ...state,
      selectedCards: isSelected ? state.selectedCards.filter(id => id !== cardId) : [...state.selectedCards, cardId],
    }
  })
}

function handleSelectAllCards(cardIds: string[]) {
  useBulkImportStore.setState(state => {
    return {
      ...state,
      selectedCards: cardIds,
    }
  })
}

export const functionsBulkImport = {
  bulkDeleteBulk,
  handleSelectCards,

  handleSelectAllCards,
  handleUpdateFieldTable,
}
